import * as Yup from "yup";
import { IFormFieldItem } from "../accountsTypes";

export const loginFormFields: IFormFieldItem[] = [
  {
    type: "text",
    name: "input",
    label: "Email/Username",
  },
  {
    type: "password",
    name: "password",
    label: "Password",
  },
];

export const validationSchema = Yup.object({
  input: Yup.string()
    .required("email or username is required")
    .typeError("value should be email or text"),
  password: Yup.string()
    .min(6, "Password length should be 6 or more characters")
    .required("Password is required"),
});
